import React, {useState, useEffect} from 'react';
import axios from 'axios';
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import CustomAlert from "../../../components/ConfirmationModal/CustomAlert";
import "./NewsManager.css"
import {
    Button,
    FormControl,
  TextField,
} from "@mui/material";
import {Autocomplete} from "@mui/lab";
import EditNewsForm from "./EditNewsForm";
import {useNavigate} from "react-router-dom";



const NewsManager = ({onAdd}) => {
    const [newsItems, setNewsItems] = useState([]);
    const [selectedNewsId, setSelectedNewsId] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const [editingNews, setEditingNews] = useState(null);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false)
    const navigate = useNavigate();

    const handleEdit = (newsId) => {
        navigate(`/dashboard/editnews/${newsId}`);
    };


    useEffect(() => {
        void fetchNews();
    }, [onAdd]);

    const fetchNews = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllNews`);
            setNewsItems(response.data.data);
        } catch (error) {
        }
    };
    const handleDelete = (id) => {
        setSelectedNewsId(id);
        setIsModalOpen(true);
    };

    const confirmDelete = async () => {
        setIsModalOpen(false);
        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/DeleteNews`, {id: selectedNewsId});
            setAlertMessage('ოპერაცია წარმატებით დასრულდა');
            setAlertType('success');
            await fetchNews();
        } catch (error) {
            setAlertMessage('დაფიქსირდა შეცდომა');
            setAlertType('error');
        }
    };

    return (
        <div className="news-manager-container">
            <FormControl fullWidth>
                <Autocomplete
                    value={newsItems.find(item => item.id === selectedNewsId) || null} // Find the full object based on ID
                    onChange={(event, newValue) => {
                        setSelectedNewsId(newValue ? newValue.id : '');
                    }}
                    options={newsItems}
                    getOptionLabel={(option) => option.title || ''}
                    noOptionsText="არაფერი მოიძებნა!"
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="აირჩიეთ სიახლე"
                            fullWidth
                        />
                    )}
                    style={{marginBottom: 10}}
                />
            </FormControl>
            <div style={{display: "flex", marginTop: 10}}>
                <Button
                    variant="contained"
                    onClick={() => handleEdit(selectedNewsId)}
                    disabled={!selectedNewsId}
                    style={{width: 100, marginRight: 10}}>
                    რედაქტირება
                </Button>

                <Button variant="contained" color="error" className="news-manager-delete-button"
                        onClick={() => handleDelete(selectedNewsId)}
                        disabled={!selectedNewsId} style={{width: 100}}>
                    წაშლა
                </Button>
            </div>


            <ConfirmationModal
                isOpen={isModalOpen}
                onRequestClose={() => setIsModalOpen(false)}
                onConfirm={confirmDelete}
            />

            {alertMessage && (
                <CustomAlert
                    message={alertMessage}
                    type={alertType}
                    onClose={() => setAlertMessage('')}
                />
            )}


        </div>

    );
};

export default NewsManager;
